import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import OptionsCard from "../../../Components/Card/AssetUI/OptionsCard";
import { useSelector, useDispatch } from "react-redux";
import { currentAssetSliceActions } from "../../../Store/Slices/CurrentAssetSlice";
import { unicodeToString } from "../../../Js/Common";
import { makeStyles } from "@material-ui/core/styles";

var initLogObj = {
  attempts: 1,
  duration: 0,
  assetType: {
    group: "practice",
    value: null,
  },
  userAnswer: [],
  isEvaluated: "auto",
  actualAnswer: [],
  genericScore: 0,
};

const DIC = (props) => {
  // Hooks
  const dispatch = useDispatch();
  const classes = useStyles();

  // State
  const [userAnswer, setUserAnswer] = useState([]);
  const [logObj, setLogObj] = useState(initLogObj);

  // Redux state
  const { showAnswer, assetLogObj, attempted, currentAttempt, optionWiseAns } = useSelector(
    (state) => state.currentAsset
  );

  useEffect(() => {
    if (props.content) {
      setUserAnswer(
        new Array(props.content.epage.options.content.length).fill([""])
      );
      dispatch(
        currentAssetSliceActions.setCurrentAttemptData(
          new Array(props.content.epage.options.content.length).fill([""])
        )
      );
      let actualAnswers = props.content.epage.options.content.map(
        (val, index) => {
          let obj = { ...val };
          if (Array.isArray(obj.text)) {
            obj.text = obj.text.map((txt) => {
              if (txt) return unicodeToString(txt).trim();
              else return "";
            });
          } else {
            obj.text = [];
          }
          return obj.text;
        }
      );
      let obj = {
        ...logObj,
        assetType: {
          ...logObj.assetType,
          value: props.content.info.asset_type_alias,
        },
        actualAnswer: actualAnswers,
      };

      if (props.content.epage.options.autoMode.toString() !== "true") {
        obj.isEvaluated = "pending";
      }
      setLogObj(obj);
    }
  }, [props.content]);

  useEffect(() => {
    dispatch(currentAssetSliceActions.setAssetLogObj(logObj));
    dispatch(currentAssetSliceActions.setShowAnswer(false));
  }, [logObj]);

  useEffect(() => {
    if (props.content.epage.options.autoMode.toString() == "true") {
      setUserAnswer(
        new Array(props.content.epage.options.content.length).fill([""])
      );
      dispatch(currentAssetSliceActions.setShowAnswer(false));
      dispatch(
        currentAssetSliceActions.setCurrentAttemptData(
          new Array(props.content.epage.options.content.length).fill([""])
        )
      );
    } else {
      console.log("elseeeeee");
    }
  }, [currentAttempt]);

  useEffect(() => {
    if (showAnswer && assetLogObj && assetLogObj.actualAnswer) {
      let showAllAnswer = assetLogObj.actualAnswer.map((val) => {
        return [val.join(" | ")];
      });
      setUserAnswer(showAllAnswer);
    }
  }, [showAnswer, assetLogObj]);

  useEffect(() => {
    return () => {
      setUserAnswer([]);
    };
  }, []);

  const updateUserAnswer = (index, text) => {
    if (!showAnswer && !attempted) {
      let newArray = [...userAnswer];
      newArray[index] = [text];
      setUserAnswer([...newArray]);
      dispatch(currentAssetSliceActions.setCurrentAttemptData([...newArray]));
    }
  };

  // JSX template

  return (
    <div  >
      {props.content &&
        props.content.epage.options.content.map((item, index) => {
          return (
            <>
              {userAnswer && userAnswer.length > 0 && userAnswer[index] && (
                <OptionsCard
                  media={item.media}
                  index={index}
                  changeText={(text) => {
                    updateUserAnswer(index, text);
                  }}
                  totalOptions={props.content.epage.options.content.length}
                  assetType={props.content.info.asset_type_alias}
                  value={userAnswer[index][0]}
                  editable={
                    props.content.epage.options.autoMode.toString() == "true"
                      ? !showAnswer && !attempted
                      : !attempted
                  }
                  optionWiseAns={optionWiseAns[index]}
                />
              )}
            </>
          );
        })}
    </div>
  );
};
const useStyles = makeStyles({
  ListItemText: {
    fontSize: "1rem !important",
  },
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
    height: '62vh',
    overflow: 'auto'
  },
  scrollBarHeight: {
    "&::-webkit-scrollbar": {
      height: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});
export default DIC;
